let socket: WebSocket | null = null;

export const getNotificationSocket = () => {
  const userId = localStorage.getItem("id");
  const token = localStorage.getItem("auth-token");

  if (!userId || !token) return null;

  if (
    socket &&
    (socket.readyState === WebSocket.OPEN ||
      socket.readyState === WebSocket.CONNECTING)
  ) {
    return socket;
  }

  const baseUrl = process.env.REACT_APP_BASE_URL || "";
  const wsProtocol = baseUrl.startsWith("https") ? "wss://" : "ws://";
  const host = baseUrl.replace(/^https?:\/\//, "").replace(/\/$/, "");

  socket = new WebSocket(
    `${wsProtocol}${host}/websocket/ws/notifications/${userId}?token=${token}`,
  );

  return socket;
};